/* vue-kerlink version 3.0.3 */
//
//
//
//
//
//
//

var script = {
  props: {
    name: {
      type: String,
      default: '',
      required: true
    },
    pictureUrl: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md'
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "avatar", class: "avatar-" + _vm.size }, [
    _vm.pictureUrl
      ? _c("div", {
          staticClass: "rounded-circle picture",
          style: "background-image:url(" + _vm.pictureUrl + ")"
        })
      : _c("div", { staticClass: "rounded-circle img-fluid initial" }, [
          _vm._v(_vm._s(_vm.name.charAt(0).toUpperCase()))
        ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-20a806f5_0", { source: ".avatar[data-v-20a806f5] {\n  position: relative;\n}\n.avatar-sm[data-v-20a806f5] {\n  width: 25px;\n  height: 25px;\n}\n.avatar-sm .initial[data-v-20a806f5] {\n  font-size: 1rem;\n}\n.avatar-md[data-v-20a806f5] {\n  width: 50px;\n  height: 50px;\n}\n.avatar-md .initial[data-v-20a806f5] {\n  font-size: 2rem;\n}\n.avatar-lg[data-v-20a806f5] {\n  width: 100px;\n  height: 100px;\n}\n.avatar-lg .initial[data-v-20a806f5] {\n  font-size: 4rem;\n}\n.avatar-xl[data-v-20a806f5] {\n  width: 150px;\n  height: 150px;\n}\n.avatar-xl .initial[data-v-20a806f5] {\n  font-size: 5rem;\n}\n.avatar .picture[data-v-20a806f5] {\n  z-index: 20;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: contain;\n}\n.avatar .initial[data-v-20a806f5] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #bbb;\n  background-color: #eee;\n}\n.active .avatar img[data-v-20a806f5],\n.active .avatar .initial[data-v-20a806f5] {\n  border: 1px solid #fab619;\n}\n\n/*# sourceMappingURL=Avatar.vue.map */", map: {"version":3,"sources":["C:\\Users\\alg\\Workspace_Dashboard\\vue-kerlink\\src\\components\\Avatar.vue","Avatar.vue"],"names":[],"mappings":"AA8BA;EACA,kBAAA;AC7BA;AD+BA;EACA,WAAA;EACA,YAAA;AC7BA;AD+BA;EACA,eAAA;AC7BA;ADiCA;EACA,WAAA;EACA,YAAA;AC/BA;ADiCA;EACA,eAAA;AC/BA;ADmCA;EACA,YAAA;EACA,aAAA;ACjCA;ADmCA;EACA,eAAA;ACjCA;ADqCA;EACA,YAAA;EACA,aAAA;ACnCA;ADqCA;EACA,eAAA;ACnCA;ADuCA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,wBAAA;ACrCA;ADwCA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;ACtCA;AD2CA;;EAEA,yBAAA;ACxCA;;AAEA,qCAAqC","file":"Avatar.vue","sourcesContent":["<template>\n  <div :class=\"'avatar-' + size\" class=\"avatar\">\n    <div v-if=\"pictureUrl\" :style=\"'background-image:url('+pictureUrl+')'\" class=\"rounded-circle picture\" />\n    <div v-else class=\"rounded-circle img-fluid initial\">{{ name.charAt(0).toUpperCase() }}</div>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: {\n    name: {\n      type: String,\n      default: '',\n      required: true\n    },\n    pictureUrl: {\n      type: String,\n      default: ''\n    },\n    size: {\n      type: String,\n      default: 'md'\n    }\n  }\n}\n</script>\n\n<style scoped lang=\"scss\">\n  @import \"../scss/variables\";\n\n  .avatar {\n    position: relative;\n\n    &-sm {\n      width: 25px;\n      height: 25px;\n\n      .initial {\n        font-size: 1rem;\n      }\n    }\n\n    &-md {\n      width: 50px;\n      height: 50px;\n\n      .initial {\n        font-size: 2rem;\n      }\n    }\n\n    &-lg {\n      width: 100px;\n      height: 100px;\n\n      .initial {\n        font-size: 4rem;\n      }\n    }\n\n    &-xl {\n      width: 150px;\n      height: 150px;\n\n      .initial {\n        font-size: 5rem;\n      }\n    }\n\n    .picture {\n      z-index: 20;\n      width: 100%;\n      height: 100%;\n      background-repeat: no-repeat;\n      background-position: 50%;\n      background-size: contain;\n    }\n\n    .initial {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 10;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: $gray-500;\n      background-color: $gray-200;\n    }\n  }\n\n  .active .avatar {\n    img,\n    .initial {\n      border: 1px solid $secondary;\n    }\n  }\n</style>\n",".avatar {\n  position: relative;\n}\n.avatar-sm {\n  width: 25px;\n  height: 25px;\n}\n.avatar-sm .initial {\n  font-size: 1rem;\n}\n.avatar-md {\n  width: 50px;\n  height: 50px;\n}\n.avatar-md .initial {\n  font-size: 2rem;\n}\n.avatar-lg {\n  width: 100px;\n  height: 100px;\n}\n.avatar-lg .initial {\n  font-size: 4rem;\n}\n.avatar-xl {\n  width: 150px;\n  height: 150px;\n}\n.avatar-xl .initial {\n  font-size: 5rem;\n}\n.avatar .picture {\n  z-index: 20;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: contain;\n}\n.avatar .initial {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #bbb;\n  background-color: #eee;\n}\n\n.active .avatar img,\n.active .avatar .initial {\n  border: 1px solid #fab619;\n}\n\n/*# sourceMappingURL=Avatar.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-20a806f5";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var Avatar = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

export default Avatar;
